export const INDENT = 32;
export const POLL_INTERVAL = 1000;

// Animation
export const DURATION = 150;
export const DEFAULT_STYLE = {
  transition: `${DURATION}ms ease-in-out`,
  opacity: 0,
};
export const TRANSITION_STYLE = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};
